import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Autocomplete from '@mui/material/Autocomplete';
import { useMemo } from 'react';
import { useCountries } from '../../app/countries';
import { withFormData } from '../with-form-data';
import { PentairTextField } from './pentair-textfield';
/**
 * Allow users select country using autocomplete
 * @param SelectCountryProps
 * @returns CountryType - code, label,phone
 */
export const PentairSelectCountry = withFormData(({ name, label, error, helperText, margin, description, value, required, onChange, ...props }) => {
    const { countries, findCountry } = useCountries();
    const filteredCountries = useMemo(() => {
        if (props.include) {
            return countries.filter((country) => props.include?.includes(country.code) && !props.exclude?.includes(country.code));
        }
        if (props.exclude) {
            return countries.filter((country) => !props.exclude?.includes(country.code));
        }
        // pxx-1588 :: sort by country label
        const sortedCountries = countries.toSorted((a, b) => a.label.localeCompare(b.label));
        return sortedCountries;
    }, [props.exclude, props.include, countries]);
    const _value = useMemo(() => {
        return (typeof value === 'string' ? findCountry(value) : value) ?? null;
    }, [value]);
    return (_jsx(Autocomplete, { id: "country-select", options: filteredCountries, getOptionLabel: (option) => option.label, componentsProps: { paper: { sx: { width: 'fit-content' } } }, renderOption: (props, option) => (_jsxs("li", { ...props, children: [_jsx("img", { loading: "lazy", width: "20", src: `https://flagcdn.com/w20/${option.code.toLowerCase()}.png`, srcSet: `https://flagcdn.com/w40/${option.code.toLowerCase()}.png 2x`, alt: "", style: { marginRight: 8 } }), option.label] })), renderInput: (params) => (_jsx(PentairTextField, { ...params, name: name, required: required, label: label, description: description, error: error, helperText: helperText, margin: margin, inputProps: {
                ...params.inputProps,
                autoComplete: 'new-password', // disable autocomplete and autofill
            } })), ...props, onChange: onChange, value: _value }));
});
export default PentairSelectCountry;
